import React, { useState } from 'react';

import { Download } from 'assets/assetsV1/iconComponents';

import { downloadEmployeeCSVStatus } from 'services/admin';

import { Button } from 'uiToolkitV1/Button';

const BulkUploadDownloadButton = ({ uuid, fileName, text = '', hideIcon = true, buttonStyles = {} }) => {
  const [downloading, setDownloading] = useState(false);

  const downloadCSVHandler = async () => {
    try {
      setDownloading(true);
      const blob = await downloadEmployeeCSVStatus(uuid);
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    } catch (err) {
      console.error('Error downloading the csv', err);
    } finally {
      setDownloading(false);
    }
  };

  const downloadButtonText = text || 'Download file';
  const iconProps = hideIcon ? {} : { StartIcon: Download };

  return (
    <Button
      sx={{ marginLeft: 'auto' }}
      variant="tertiary"
      isDisabled={downloading}
      onClick={downloadCSVHandler}
      {...iconProps}
      {...buttonStyles}
    >
      {downloadButtonText}
    </Button>
  );
};

export { BulkUploadDownloadButton };
